import { useContext, useEffect, useState } from 'react';
import AuthenticationContext from '../../../contexts/auth/AuthenticationContext';
import CompanyContext from '../../../contexts/company/CompanyContext';
import { getCompanyAiReceptionistCallRecording } from '../../../../domain/use_cases/ai-receptionist/getCompanyAiReceptionistCallRecording';

// The audio URL is signed by the backend (1h) and left out of the call list: fetched when the call is shown
const useReceptionistCallRecordingController = (callId: string, hasRecording: boolean) => {
  const { authentication } = useContext(AuthenticationContext);
  const { activeCompany } = useContext(CompanyContext);

  const [recording, setRecording] = useState<{ callId: string; url: string } | null>(null);

  const [failedCallId, setFailedCallId] = useState<string | null>(null);

  const companyId = activeCompany?.id;
  const isLoaded = recording?.callId === callId;
  const hasFailed = failedCallId === callId;

  useEffect(() => {
    if (!hasRecording || isLoaded || hasFailed || !companyId || !authentication) return;

    let isCancelled = false;
    getCompanyAiReceptionistCallRecording({ company_id: companyId, call_id: callId }, authentication)
      .then((response) => {
        if (!isCancelled) setRecording({ callId, url: response.recording_url });
      })
      .catch(() => {
        if (!isCancelled) setFailedCallId(callId);
      });
    return () => {
      isCancelled = true;
    };
  }, [hasRecording, isLoaded, hasFailed, callId, companyId, authentication]);

  return {
    state: {
      url: isLoaded ? recording.url : '',
      isLoading: hasRecording && !isLoaded && !hasFailed,
      hasFailed,
    },
  };
};

export default useReceptionistCallRecordingController;
